import React from 'react';
import Typography from 'Components/DesignSystem/Typography/Typography';
import Button from 'Components/DesignSystem/Button/Button';
import ModalWrapper from './ModalWrapper';

interface ConfirmActionModalProps {
  isOpen: boolean;
  onClose: () => void;
  onConfirm: () => void;
  title?: string;
  message: string;
  confirmLabel?: string;
  cancelLabel?: string;
  isLoading?: boolean;
}

/**
 * ConfirmActionModal Component
 *
 * Styled confirmation dialog for row actions and bulk actions.
 * Uses ModalWrapper for consistent look and feel.
 */
const ConfirmActionModal: React.FC<ConfirmActionModalProps> = ({
  isOpen,
  onClose,
  onConfirm,
  title = 'Confirm Action',
  message,
  confirmLabel = 'Confirm',
  cancelLabel = 'Cancel',
  isLoading = false,
}) => {
  return (
    <ModalWrapper
      isOpen={isOpen}
      onClose={onClose}
      title={title}
      width="sm"
      footer={
        <div className="tw-flex tw-justify-end tw-gap-3">
          <Button variant="tertiary" onClick={onClose} disabled={isLoading} data-testid="catalog-confirm-cancel-btn">
            {cancelLabel}
          </Button>
          <Button variant="primary" onClick={onConfirm} disabled={isLoading} data-testid="catalog-confirm-confirm-btn">
            {isLoading ? 'Processing...' : confirmLabel}
          </Button>
        </div>
      }
    >
      <Typography variant="body-primary" className="tw-text-ink-secondary">
        {message}
      </Typography>
    </ModalWrapper>
  );
};

export default ConfirmActionModal;
